export function formattedDate(dateS: string) {
	const updatedAt = dateS ? twoDigitDate(new Date(dateS)) : null
	if (updatedAt) {
		return `${updatedAt.day}.${updatedAt.month}.${updatedAt.year} ${updatedAt.hours}:${updatedAt.minutes}`
	} else {
		return "–"
	}
}

function twoDigitValue(num: number) {
	return `${("000" + num).slice(-2)}`
}

function twoDigitDate(date: Date) {
	return {
		year: date.getFullYear(),
		month: twoDigitValue(date.getMonth() + 1),
		day: twoDigitValue(date.getDate()),
		hours: twoDigitValue(date.getHours()),
		minutes: twoDigitValue(date.getMinutes()),
		seconds: twoDigitValue(date.getSeconds()),
	}
}
